<template>
    <div>
        <b-modal
            id="modalAnexoForm"
            v-model="mostrarModal"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Pagamento - Anexo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexosSelect"
                            v-model="tipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                    </b-form-group>
                    <b-alert show v-if="tipo && tipo.ajuda">{{
                        tipo.ajuda
                    }}</b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-input
                            type="text"
                            placeholder="Descritivo"
                            v-model="descritivo"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O descritivo do anexo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="mostrarCampoNumeroDocumento">
                <b-col sm="12">
                    <b-form-group>
                        <label>Número do Documento</label>
                        <b-form-input
                            type="text"
                            v-model="numeroDocumento"
                            @input="$v.numeroDocumento.$touch()"
                            :state="$v.numeroDocumento.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O número do documento é
                            obrigatório</b-form-invalid-feedback
                        >
                        <b-alert show class="mt-2 mb-0"
                            >Caso esse campo não seja aplicável, informar
                            "N/A"</b-alert
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row
                v-if="temDataEmissao"    
            >
                <b-col>
                    <b-form-group>
                        <label>Data de emissão</label>
                        <date-picker
                            v-model="dataEmissao"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharAnexoForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarAnexo()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'pagamento-anexo-form',

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        mostrarCampoNumeroDocumento: {
            type: Boolean,
            default: () => true
        },

        temDataEmissao: {
            type: Boolean,
            default: () => false
        },

        tipoAnexoDocumento: {
            type: String,
            default: () => 'A'
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'INSERIR',
            erros: [],
            obterPagamentoAtualizado: false,
            tiposAnexosSelect: [],
            tipoId: '',
            descritivo: '',
            numeroDocumento: this.mostrarCampoNumeroDocumento ? '' : 'N/A',
            dataEmissao: null,
            arquivo: null
        }
    },

    methods: {
        fecharAnexoForm() {
            this.mostrarModal = false
            this.resetAnexoForm()
            if (this.obterPagamentoAtualizado) {
                this.$emit('obterPagamentoAtualizado')
            }
        },

        resetAnexoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.numeroDocumento = this.mostrarCampoNumeroDocumento ? '' : 'N/A'
            this.dataEmissao = null
            this.erros = []
            this.arquivo = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterPagamentoAtualizado = false
        },

        salvarAnexo() {
            this.mostrarModal = false
            let anexoData = {
                pagamentoId: this.pagamento.pagamentoId,
                tipoId: this.tipoId,
                descritivo: this.descritivo,
                numeroDocumento: this.numeroDocumento,
                dataEmissao: this.$moment(this.dataEmissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                arquivo: this.arquivo
            }

            if (this.tipoAnexoDocumento === 'A') {
                this.validarAnexo(anexoData)
            } else {
                this.inserirAnexo(anexoData)
            }
            
        },

        validarAnexo(anexoData) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.validarInserirPagamentoAnexo(anexoData)
                .then((response) => {
                    if (response) {
                        if (response.success && response.data) {
                            this.$store.dispatch('removeRequest')
                            this.inseridoComSucesso()
                        } else if (response.success && !response.data) {
                            this.$store.dispatch('removeRequest')
                            this.justificativaAnexoDuplicado(anexoData)
                        } else {
                            this.$store.dispatch('removeRequest')
                            this.erros = response.errors
                            this.mostrarModal = true
                        }
                    } else {
                        this.$store.dispatch('removeRequest')
                    } 
                })
        },

        justificativaAnexoDuplicado(anexoData) {
            this.$swal({
                title: 'Justificativa para anexo duplicado',
                html: `Para confirmar a inserção de um anexo duplicado é necessario inserir uma justificativa.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa para este anexo',
                inputValidator: (value) => {
                    if (!value) {
                        return 'A justificativa do anexo duplicado é obrigatória'
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.inserirAnexo(anexoData, result.value)
                }
            })
        },

        inserirAnexo(anexoData, justificativa=null) {
            anexoData.justificativa = justificativa
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .inserirPagamentoAnexo(anexoData)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.inseridoComSucesso()
                        } else {
                            this.erros = response.errors
                            this.mostrarModal = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inseridoComSucesso() {
            this.$toast.success(
                'Registro atualizado com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.obterPagamentoAtualizado = true
            this.resetAnexoForm()
            this.fecharAnexoForm()
        },

        obterAnexosTipos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterAnexosTipos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexosSelect = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexosSelect.find(
                (p) => p.anexoTipoId == this.tipoId
            )
            return tiposTemp ? tiposTemp : {}
        }
    },

    created() {
        if (
            this.$temAcesso('GESCON-FORN-PAG-03') ||
            this.$temAcesso('GESCON-UFI-PAG-05')
        ) {
            this.obterAnexosTipos()
        }
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            required
        },
        descritivo: {
            required
        },
        numeroDocumento: {
            required
        }
    }
}
</script>
